'use strict';
var parent = require('../../stable/promise/with-resolvers');
// TODO: Remove from `core-js@4`
require('../../modules/esnext.promise.with-resolvers');

module.exports = parent;
